import discountsStrings from "./strings";
import { DiscountStatus } from "./types/discount.types";

export enum DiscountLifecycleStatus {
  Scheduled = 'Scheduled',
  Active = 'Active',
  Stopped = 'Stopped',
  Completed = 'Completed',
}


export const discountLifecycleStatus = {
  All: 0,
  [DiscountLifecycleStatus.Scheduled]: 1,
  [DiscountLifecycleStatus.Active]: 2,
  [DiscountLifecycleStatus.Stopped]: 3,
  [DiscountLifecycleStatus.Completed]: 4,
} as const;

export const discountStockFilter = {
  All: 0,
  InStock: 1,
  OutOfStock: 2,
} as const;

export enum DiscountActions {
  Stop = 'Stop',
  Republish = 'Republish',
  Edit = 'Edit',
}

export const DEFAULT_ACTION_LABELS: Record<DiscountActions, string> = {
  [DiscountActions.Stop]: 'Stop Offer',
  [DiscountActions.Edit]: 'Edit Offer',
  [DiscountActions.Republish]: 'Republish this offer',
};


export const STATUS_TYPE_TO_STRING_MAP: Record<string, string> = {
  [DiscountLifecycleStatus.Scheduled]: discountsStrings.statusScheduled,
  [DiscountLifecycleStatus.Active]: discountsStrings.statusActive,
  [DiscountLifecycleStatus.Stopped]: discountsStrings.statusStopped,
  [DiscountLifecycleStatus.Completed]: discountsStrings.statusCompleted,
};


export const DISCOUNT_LIST_PAGE_SIZE = 20;
export const PRODUCT_SEARCH_PAGE_SIZE = 20;
export const PRODUCT_SEARCH_DEBOUNCE_MS = 400;

export const PRODUCT_TYPE = {
  Product: 1,
  Bundle: 2,
} as const;

export const discountItemTypeFilter = {
  All: 0,
  [PRODUCT_TYPE.Product]: PRODUCT_TYPE.Product,
  [PRODUCT_TYPE.Bundle]: PRODUCT_TYPE.Bundle,
} as const;

export const DISCOUNT_VALUE_TYPES = {
  Percent: 'percent',
  Amount: 'amount',
} as const;

export const DISCOUNT_TYPE_API = {
  Percent: 1,
  Amount: 2,
} as const;

export const OFFER_PROVIDER_TYPE = 'pharmacy';
